import { Modal } from '@mui/material';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box } from '@mui/system';
import H6 from './H6';
import Subtitle1 from './Subtitle1';
import Button from '@mui/material/Button';

import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const ModalContainer = styled(Box)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	max-width: 400px;
	border-radius: 4px;
	background: white;
`;

const CloseButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding: 32px 32px 0 0;
`;

const CloseButton = styled.div`
	cursor: pointer;
`;

const ContentContainer = styled.div`
	padding: 0 32px 16px 32px;
`;

const ActionContainer = styled(Box)`
	padding: 20px 32px;
	display: flex;
	justify-content: center;
	column-gap: 5px;
	background: #f7f7f7;
`;

const ActionButton = styled(Button)`
	padding: 8px;
`;

export const ConfirmationDialog = ({ openDialog, title, message, yesHandler, data, onClose }) => {
	const [open, setOpen] = useState(false);

	const handleClose = () => {
		openDialog.show = false;
		setOpen(false);
		onClose(true);
	};
	const handleConfirm = () => {
		setOpen(false);
		openDialog.show = false;
		yesHandler(data);
	};

	useEffect(() => {
		setOpen(openDialog.show ? openDialog.show : false);
	}, [openDialog]);

	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<ModalContainer>
				<CloseButtonContainer>
					<CloseButton>
						<CloseIcon onClick={handleClose} />
					</CloseButton>
				</CloseButtonContainer>
				<ContentContainer>
					<H6 id="modal-modal-title">{title}</H6>
					<Subtitle1 id="modal-modal-description" sx={{ mt: 1 }}>
						{message}
					</Subtitle1>
				</ContentContainer>
				<ActionContainer>
					<ActionButton
						variant="outlined"
						onClick={handleClose}
						startIcon={<CloseIcon size="large" />}
						fullWidth
					>
						Cancel
					</ActionButton>
					<ActionButton
						variant="contained"
						onClick={handleConfirm}
						startIcon={<CheckIcon size="large" />}
						fullWidth
					>
						Confirm
					</ActionButton>
				</ActionContainer>
			</ModalContainer>
		</Modal>
	);
};
